// @flow
import PageViewRecorder from './PageViewRecorder';
export default PageViewRecorder;
